import type {SubmitEvent} from 'react'
import {Input} from '@freckle/educator-entities/ts/common/components/base/input'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1, H3} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {form, formGroup, forgotPassword, footer} from './login-view.module.scss'

type Props = {
  email?: string
  password?: string
  disabled: boolean
  onChangeEmail: (email: string) => void
  onChangePassword: (password: string) => void
  onSubmitLogin: (e: SubmitEvent<HTMLFormElement>) => void
}

export default function LoginView(props: Props) {
  const {t} = useSafeTranslation()
  const {email, password, disabled, onChangeEmail, onChangePassword, onSubmitLogin} = props

  const supportNumberLink = <Link href="tel:+1-800-338-4204" reactRouter={false} />
  const supportLink = <Link href="mailto:freckle-support@renaissance.com" reactRouter={false} />

  return (
    <CenteredPage>
      <H1>{t('LOGIN_PAGE_TITLE')}</H1>
      <H3>{t('LOGIN_PAGE_DESCRIPTION_TEXT')}</H3>
      <form action="" method="post" onSubmit={onSubmitLogin} className={form}>
        <div className={formGroup}>
          <Input
            className="form-control"
            name="email"
            onChange={onChangeEmail}
            type="email"
            placeholder={t('LOGIN_PAGE_EMAIL_PLACEHOLDER_TEXT')}
            autoCorrect="off"
            required
            value={email}
            disabled={disabled}
            dataTest="login-email-input"
          />
        </div>
        <div className={formGroup}>
          <Input
            className="form-control"
            name="password"
            onChange={onChangePassword}
            type="password"
            autoComplete="off"
            placeholder={t('LOGIN_PAGE_PASSWORD_PLACEHOLDER_TEXT')}
            value={password}
            disabled={disabled}
            dataTest="login-password-input"
          />
          <Link href={Routes.forgotPassword()} className={forgotPassword} reactRouter>
            {t('LOGIN_PAGE_FORGOT_PASSWORD_LINK_TEXT')}
          </Link>
        </div>
        <Button style="primary" type="submit" disabled={disabled} dataTest="login-submit">
          {t('LOGIN_PAGE_LOGIN_BUTTON_TEXT')}
        </Button>
      </form>
      <div className={footer}>
        <SafeTrans
          i18nKey="LOGIN_PAGE_CREATE_ACCOUNT_INFO_TEXT"
          components={{supportNumberLink, supportLink}}
        />
      </div>
    </CenteredPage>
  )
}
